import { Card } from './UI';
import RecruitChip from './RecruitChip';

// «Подменник»: подменные мерчи (лист ПМ). Без заказа, планирования и факта: только список, статус подбора и отпуска.
export default function PmBlock({ routes, onEdit }) {
  if (!routes || !routes.length) return null;
  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: '#6B46C1', textTransform: 'uppercase', letterSpacing: '.05em', margin: '0 0 6px 2px' }}>
        Подменник · {routes.length}
      </div>
      <Card>
        {routes.map(route => {
          const m = Array.isArray(route.merchandisers) ? route.merchandisers[0] : route.merchandisers;
          const name = m?.full_name && !/вакансия/i.test(m.full_name) ? m.full_name : 'Вакансия';
          return (
            <div key={route.id} style={{ padding: '10px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 9, fontWeight: 700, color: '#6B46C1', background: '#EDE7F6', borderRadius: 4, padding: '1px 5px' }}>ПМ</span>
              <span style={{ fontSize: 13, fontWeight: 600, fontStyle: name === 'Вакансия' ? 'italic' : 'normal', color: name === 'Вакансия' ? 'var(--text-muted)' : 'var(--text)' }}>{name}</span>
              <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{route.internal_code}</span>
              <RecruitChip routeId={route.id} />
              {onEdit && (
                <button onClick={() => onEdit(route)} style={{ marginLeft: 'auto', fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 6, border: '1px solid var(--border)', background: '#fff', color: 'var(--accent)', cursor: 'pointer' }}>
                  ✎ ФИО
                </button>
              )}
            </div>
          );
        })}
      </Card>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6 }}>Отпуска подменных — во вкладке «Отпуска».</div>
    </div>
  );
}
